import LegacyPagination from './LegacyPagination';

export * from './LegacyPagination';

export default LegacyPagination;
